// GardenerPolicy.js

// Raw text version for DB storage
export const POLICY_TEXT = `
GrowYourFoodApp Gardener Subscription and Payment Agreement
Version: 2026-04
Effective Date: April 5, 2026

By subscribing to GrowYourFoodApp and participating as a Gardener on the platform,
you agree to the following terms. This Agreement outlines your subscription terms,
billing expectations, preorder payment authorization, and responsibilities as a user
of the GrowYourFoodApp service.

1. Subscription and Billing
- Your subscription is billed monthly through Stripe.
- Billing begins immediately upon successful checkout.
- Your subscription renews automatically each month.
- You may cancel at any time through your account settings.
- Cancellation stops future billing but does not refund past charges.

2. Payment Method Usage
- The payment method you provide during subscription setup will be securely stored by Stripe.
- This payment method may also be used for optional preorders you choose to place.
- You authorize GrowYourFoodApp to charge this payment method for preorder items.
- You will be notified of preorder totals before any charge is attempted.

3. Preorder Charges
- Preorders are optional and initiated by you.
- Charges for preorders occur only when items are ready for fulfillment.
- Stripe may attempt charges automatically using your saved payment method.
- Failed preorder payments may result in order cancellation.

4. Communication and Notifications
- You agree to receive notifications related to subscription billing and preorders.
- You are responsible for keeping your email and payment information up to date.

5. Conduct and Platform Use
- You agree to use the platform respectfully and responsibly.
- You will not misuse supplier information or attempt off-platform transactions.
- You will not engage in fraudulent, abusive, or harmful behavior.

6. Data and Privacy
- Your payment information is stored and processed only by Stripe.
- GrowYourFoodApp does not store or access your full payment details.
- Your personal information is used only for platform functionality and communication.

7. Policy Updates
GrowYourFoodApp may update this Agreement in the future. If updates are made, you may be required
to review and accept the new version before continuing to use the platform.

8. Termination
GrowYourFoodApp reserves the right to suspend or remove gardeners who violate this Agreement,
engage in fraudulent activity, or create risk or harm to suppliers, customers, or the platform.

By clicking "I Agree", you confirm that you have read and understood this Agreement, authorize
GrowYourFoodApp to process subscription and preorder payments as described, and agree to follow
all requirements listed above.
`;

// JSX version for display
const GardenerPolicy = () => (
    <div className="instructions">
        <h2>GrowYourFoodApp Gardener Subscription and Payment Agreement</h2>

        <div className="policy-section">
            <p><strong>Version:</strong> 2026-04</p>
            <p><strong>Effective Date:</strong> April 5, 2026</p>
        </div>

        <ul>
            <p>
                By subscribing to GrowYourFoodApp and participating as a Gardener on the platform,
                you agree to the following terms. This Agreement outlines your subscription terms,
                billing expectations, preorder payment authorization, and responsibilities as a user
                of the GrowYourFoodApp service.
            </p>

            <h3>1. Subscription and Billing</h3>
            <li>Your subscription is billed monthly through Stripe.</li>
            <li>Billing begins immediately upon successful checkout.</li>
            <li>Your subscription renews automatically each month.</li>
            <li>You may cancel at any time through your account settings.</li>
            <li>Cancellation stops future billing but does not refund past charges.</li>

            <h3>2. Payment Method Usage</h3>
            <li>The payment method you provide during subscription setup will be securely stored by Stripe.</li>
            <li>This payment method may also be used for optional preorders you choose to place.</li>
            <li>You authorize GrowYourFoodApp to charge this payment method for preorder items.</li>
            <li>You will be notified of preorder totals before any charge is attempted.</li>

            <h3>3. Preorder Charges</h3>
            <li>Preorders are optional and initiated by you.</li>
            <li>Charges for preorders occur only when items are ready for fulfillment.</li>
            <li>Stripe may attempt charges automatically using your saved payment method.</li>
            <li>Failed preorder payments may result in order cancellation.</li>

            <h3>4. Communication and Notifications</h3>
            <li>You agree to receive notifications related to subscription billing and preorders.</li>
            <li>You are responsible for keeping your email and payment information up to date.</li>

            <h3>5. Conduct and Platform Use</h3>
            <li>You agree to use the platform respectfully and responsibly.</li>
            <li>You will not misuse supplier information or attempt off-platform transactions.</li>
            <li>You will not engage in fraudulent, abusive, or harmful behavior.</li>

            <h3>6. Data and Privacy</h3>
            <li>Your payment information is stored and processed only by Stripe.</li>
            <li>GrowYourFoodApp does not store or access your full payment details.</li>
            <li>Your personal information is used only for platform functionality and communication.</li>

            <h3>7. Policy Updates</h3>
            <p>
                GrowYourFoodApp may update this Agreement in the future. If updates are made, you may be required
                to review and accept the new version before continuing to use the platform.
            </p>

            <h3>8. Termination</h3>
            <p>
                GrowYourFoodApp reserves the right to suspend or remove gardeners who violate this Agreement,
                engage in fraudulent activity, or create risk or harm to suppliers, customers, or the platform.
            </p>

            <h3>Agreement</h3>
            <p>
                By clicking "I Agree", you confirm that you have read and understood this Agreement, authorize
                GrowYourFoodApp to process subscription and preorder payments as described, and agree to follow
                all requirements listed above.
            </p>
        </ul>
    </div>
);

export default GardenerPolicy;
